import { render } from "./RiProdcategory02.vue?vue&type=template&id=0788a7a4"
import script from "./RiProdcategory02.vue?vue&type=script&lang=js"
export * from "./RiProdcategory02.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory02.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0788a7a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0788a7a4', __exports__)) {
    api.reload('0788a7a4', __exports__)
  }
  
  module.hot.accept("./RiProdcategory02.vue?vue&type=template&id=0788a7a4", () => {
    api.rerender('0788a7a4', render)
  })

}


export default __exports__